export const DEFAULT_PAGE_SIZE = 20

// Hierarchy view (folder diagram) is not paginated - upper bound on documents fetched at once.
export const HIERARCHY_PAGE_SIZE = 1000
